import { z as e, c as r, l as s, p as l, a as u, n as c } from "./v1-BlFVAz1H.js";
const n = e.object({
  percentile: e.number(),
  q1: e.number(),
  q2: e.number(),
  q3: e.number()
}), t = r.extend({
  distribution: n.nullable(),
  supplier_id: e.string().nullish(),
  category_name: e.string().nullish(),
  overall_contract_price_currency_code: e.string().nullish(),
  overall_contract_discount_currency_code: e.string().nullish()
}), i = s.extend({
  distribution: n.nullish(),
  start_date: e.string().nullish(),
  end_date: e.string().nullish()
}), a = e.object({
  sku_id: e.string().nullish(),
  name: e.string(),
  currency_code: e.string().nullish(),
  total_price: e.number(),
  total_quantity: e.number().nullish().default(1),
  total_term_months: e.number().nullish(),
  discount_percentage: e.number().nullish(),
  start_date: e.string().nullish(),
  end_date: e.string().nullish(),
  distribution: n.nullish(),
  pricing_unit_name: e.string().nullish(),
  line_item_count: e.number(),
  line_items: e.array(i),
  annualized_unitized_line_item_distribution: e.array(e.number()).nullish(),
  value_dimension: e.enum(["AnnualUnitPrice", "TotalPrice", "DiscountPercent"]),
  bucket_dimension: e.enum(["Quantity", "TotalPrice"]),
  visualization_type: e.enum(["distribution", "range"]),
  low_value_point: e.number().nullish(),
  high_value_point: e.number().nullish()
}), o = u, m = c, _ = l.extend({
  line_items: e.undefined(),
  aggregated_line_items: e.array(a),
  contract_overview: t,
  ai_summary: e.string()
}), d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aggregatedLineItemsSchema: a,
  competitiveAnalysisSchema: o,
  contractOverviewSchema: t,
  distributionSchema: n,
  lineItemSchema: i,
  negotiationInsightSchema: m,
  priceCheckOutputSchema: _
}, Symbol.toStringTag, { value: "Module" }));
export {
  a,
  o as b,
  t as c,
  n as d,
  i as l,
  m as n,
  _ as p,
  d as v
};
